import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { finalize } from 'rxjs/operators'
import { ApiService } from 'src/app/services/api.service'
import { AccountDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { BaseError, Http401Error } from 'src/utils/errors'
import { handleArpioError } from 'src/utils/handle-error'

@Component({
  selector: 'auth-verify-email',
  templateUrl: './auth-verify-email.component.html',
  styleUrls: ['./auth-verify-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthVerifyEmail implements OnInit {
  verified = false
  validContext = true
  verificationError = false
  loading = false

  private accounts: Array<AccountDto> = null

  constructor(
    private apiService: ApiService,
    private uiService: UiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    if (!this.route.snapshot.queryParamMap.has('verifyToken')) {
      this.validContext = false
    } else {
      this.loading = true
      let verifyToken = this.route.snapshot.queryParamMap.get('verifyToken')
      this.apiService.verifyEmail(verifyToken).subscribe(
        () => {
          this.apiService
            .listAccounts()
            .pipe(
              finalize(() => {
                this.verified = true
                this.loading = false
              })
            )
            .subscribe(
              (accounts) => {
                this.accounts = accounts
              },
              (error) => {
                if (error instanceof Http401Error) {
                  this.accounts = []
                } else {
                  handleArpioError(window.location.href, this.apiService, this.uiService)(error)
                }
              }
            )
        },
        (error: BaseError) => {
          this.verificationError = true
          this.loading = false
          if (error instanceof Http401Error) {
            // the token failed verification - potentially expired.
          } else {
            handleArpioError(window.location.href, this.apiService, this.uiService)(error)
          }
        }
      )
    }
  }

  get usersLink() {
    return this.uiService.buildAccountUsersUrl(this.accounts[0].accountId)
  }
}
